var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppModal", {
    attrs: {
      id: "delete-customer-modal",
      action: "Delete Customer",
      "secondary-action": "Cancel",
      title: "Are you sure?",
      actionColor: "danger",
      loading: _vm.loading,
      secondaryActionColor: "black",
      subheading: _vm.bodyText,
      hideClose: ""
    },
    on: {
      close: _vm.closeModal,
      "secondary-cta": _vm.closeModal,
      cta: _vm.deleteCustomer
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }